import ListViewLeftPart from '../../components/CountryComponent/ListViewLeftPart/ListViewLeftPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(ListViewLeftPart);
